import type { AllRouteEndpoints } from "../routeTypes";

export const companiesCompanyIdSenderVerificationIpAddressesCacheKeys: AllRouteEndpoints[] = [];
export const companiesCompanyIdSenderVerificationIpAddresses =
  "/companies/:company_id/sender_verification/ip_addresses";
